<template>
  <div class="fixedtoi">
    <!-- Header réseaux sociaux + recherche -->
    <header class="d-flex align-items-center justify-content-end" style="padding-right: 50px; background-color: #82a93c; height: 50px; color: white;">
      
      <!-- Formulaire de recherche -->
      <form class="d-flex position-relative me-4" @submit.prevent>
        <input
          v-model="search"
          @input="onSearch"
          @keyup="onSearch"
          type="text"
          class="form-control"
          placeholder=""
        />

        <ul v-if="searchResults.length" class="list-group position-absolute search-results" style="top: 100%; left: 0; right: 0; z-index: 3000; max-height: 400px; min-width: 200px; overflow-y: auto;">
          <li
            v-for="result in searchResults"
            :key="result.uid"
            class="list-group-item list-group-item-action"
            @click="goToResult(result)"
          >
            <span v-if="result.type === 'animal'">🐾</span>
            <span v-if="result.type === 'news'">📰</span>
            {{ result.title }}
          </li>
        </ul>
      </form>

      <!-- Réseaux sociaux -->
      <a href="https://www.facebook.com/p/Spa-Tarbes-100079936125235/?locale=fr_FR" target="_blank" style="color: white; text-decoration: none; margin-right: 30px; margin-left: 10px;">
        <i class="fab fa-facebook-f"></i>
      </a>
    </header>

    <!-- NAVBAR -->
    <nav class="navbar navbar-expand-lg navbar-light bg-light">
      <div class="container-fluid">
        <a class="navbar-brand" href="/">
          <img :src="'https://admin.asso-refuge.fr/images/' + informations.logo" :alt="informations.title" width="75" />
         SPA Tarbes | Bigorre
        </a>

        <button class="navbar-toggler" type="button" @click="toggleNavbar">
          <span class="navbar-toggler-icon"></span>
        </button>

        <div :class="['collapse', 'navbar-collapse', { show: !isCollapsed }]">

          <!-- Menu -->
          <ul class="navbar-nav ms-auto">
            <li class="nav-item">
            
            </li>


            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" role="button" data-bs-toggle="dropdown">Le refuge</a>
              <ul class="dropdown-menu">
                <li>
                  <router-link class="nav-link" to="/page/17" @click="toggleNavbar">Présentation</router-link>
                </li>
                <li>
                  <router-link class="nav-link" to="/page/18" @click="toggleNavbar">Pourquoi venir ?</router-link>
                </li>
              </ul>

            </li>

            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" role="button" data-bs-toggle="dropdown">Nos animaux</a>
              <ul class="dropdown-menu">
                <li>
                  <router-link class="dropdown-item" :to="{ path: '/animaux', query: { type: 'chien' }}" @click="toggleNavbar">Chiens</router-link>
                </li>
                <li>
                  <router-link class="dropdown-item" :to="{ path: '/animaux', query: { type: 'chat' }}" @click="toggleNavbar">Chats</router-link>
                </li>

              </ul>
            </li>

        


            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" role="button" data-bs-toggle="dropdown">Stérilisation</a>
              <ul class="dropdown-menu">
                <li>
                  <router-link class="nav-link" to="/page/15" @click="toggleNavbar">Stérilisation chat</router-link>
                </li>
                <li>
                  <router-link class="nav-link" to="/page/14" @click="toggleNavbar">Stérilisation chien</router-link>
                </li>
              </ul>
            </li>
           
     

         

            <li class="nav-item">
              <router-link class="nav-link" to="/page/16"  @click="toggleNavbar">Don</router-link>
            </li>


          </ul>
        </div>
      </div>
    </nav>
  </div>

  <router-view></router-view>
</template>

<script>
export default {
  data() {
    return {
      informations: {},
      isCollapsed: true,
      search: '',
      animaux: [],
      news: [],
      searchResults: [],
    }
  },

  mounted() {
    const idSite = this.$idSite

    fetch(`https://admin.asso-refuge.fr/getInformations/${idSite}`)
      .then(r => r.json())
      .then(data => this.informations = data[0] || {})

    fetch(`https://admin.asso-refuge.fr/getAnimal/${idSite}`)
      .then(r => r.json())
      .then(data => this.animaux = data || [])

    fetch(`https://admin.asso-refuge.fr/getNews/${idSite}`)
      .then(r => r.json())
      .then(data => this.news = data || [])

    // Fermer dropdown quand on clique en dehors
    document.addEventListener('click', this.closeSearch)
  },

  beforeUnmount() {
    document.removeEventListener('click', this.closeSearch)
  },

  methods: {
    toggleNavbar() {
      this.isCollapsed = !this.isCollapsed
    },

    objectContains(obj, query) {
      return Object.values(obj).some(value => {
        if (!value) return false
        if (typeof value === 'string') return value.toLowerCase().includes(query)
        if (typeof value === 'object') return this.objectContains(value, query)
        return false
      })
    },

    onSearch() {
      const q = this.search.toLowerCase().trim()

      if (!q || q.length < 2) {
        this.searchResults = []
        return
      }

      // Animaux
      const animalsResults = this.animaux
        .filter(a =>
          a.name?.toLowerCase().includes(q) ||
          a.sexe?.toLowerCase().includes(q) ||
          a.couleur?.toLowerCase().includes(q) ||
          a.race?.toLowerCase().includes(q)
        )
        .map(a => ({
          uid: 'animal-' + a.id,
          id: a.id,
          title: a.name || 'Animal',
          type: 'animal'
        }))

      // Actualités
      const newsResults = this.news
        .filter(n => this.objectContains(n, q))
        .map(n => ({
          uid: 'news-' + n.id,
          id: n.id,
          title: n.nom || 'Actualité',
          type: 'news'
        }))

      this.searchResults = [...animalsResults, ...newsResults].slice(0, 10)
    },

    goToResult(result) {
      this.search = ''
      this.searchResults = []

      if (result.type === 'animal') this.$router.push(`/animaux/${result.id}`)
      if (result.type === 'news') this.$router.push(`/publication/${result.id}`)

      this.isCollapsed = true
    },

    closeSearch(e) {
      if (!e.target.closest('form')) this.searchResults = []
    }
  }
}
</script>

<style src="../assets/css/refonte.css"></style>
